import {InlineTable} from 'src/feature/bite/component'
import moment from 'moment'
import {useFormikContext} from 'formik'

const ProviderContract = ({
  loading,
  intl,
  editable,
  setEditable,
}: {
  loading: boolean
  intl: any
  editable: any
  setEditable: any
}) => {
  const column = [
    [
      {
        key: 'contractDate',
        dataIndex: 'contractDate',
        title: intl.formatMessage({id: 'STORE.CONTRACT_DATE'}),
        render: (contractDate: any) => {
          return <>{moment.utc(contractDate).format('DD/MM/YYYY')}</>
        },
        tooltip: 'The date when your contract with Vasco was initiated.',
      },
      {
        key: 'contractURL',
        dataIndex: 'contractURL',
        title: intl.formatMessage({id: 'STORE.CONTRACT_SIGNED'}),
        render: (contractDocument: string) => {
          return (
            <a
              href={contractDocument}
              target='_blank'
              rel='noreferrer'
              className='text-primary fs-6'
            >
              View File
            </a>
          )
        },
        tooltip: 'Your contract in PDF format for reference.',
      },
    ],
    [
      {
        key: 'contractDuration',
        dataIndex: 'contractDuration',
        title: intl.formatMessage({id: 'STORE.CONTRACT_DURATION'}),
        tooltip: 'Specifies the length of your contract, indicating its validity period.',
      },
      {
        key: 'onBoardingDate',
        dataIndex: 'onBoardingDate',
        title: intl.formatMessage({id: 'STORE.DETAIL.OVERVIEW.AGREEMENT_DATE'}),
        render: (onBoardingDate: any) => {
          return <>{moment.utc(onBoardingDate).format('DD/MM/YYYY')}</>
        },
        tooltip: 'The date when your freelancer account was successfully onboarded.',
      },
    ],
  ]

  const {values, initialValues} = useFormikContext() as any

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>{intl.formatMessage({id: 'STORE.CONTRACT'})}</h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({id: 'STORE.CONTRACT_TOOLTIP'})}
            </p>
          </div>
        </div>
      </div>

      <div className='card-body p-9'>
        <InlineTable
          loading={loading}
          dataSource={initialValues}
          columns={column}
          editable={false}
          values={values}
        />
      </div>
    </div>
  )
}

export default ProviderContract
